import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

export function Header({ onContactClick, onSectionClick }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById("accueil");
      if (heroSection) {
        const heroHeight = heroSection.offsetHeight;
        setIsScrolled(window.scrollY > heroHeight);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSectionClick = (sectionId) => {
    setIsMenuOpen(false);
    onSectionClick(sectionId);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 ${
        isScrolled
          ? "bg-[#0A0A0A]/90 backdrop-blur-sm shadow-lg"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img
              src="/assets/icons/logo-blanc.svg"
              alt="PLR Park Logo"
              className="h-6 w-auto"
            />
          </div>

          {/* Menu Desktop */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => handleSectionClick("accueil")}
              className="text-white hover:text-[#FF7954] transition-colors"
            >
              Accueil
            </button>
            <button
              onClick={() => handleSectionClick("services")}
              className="text-white hover:text-[#FF7954] transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => handleSectionClick("tarifs")}
              className="text-white hover:text-[#FF7954] transition-colors"
            >
              Tarifs
            </button>
            <button
              onClick={onContactClick}
              className="bg-[#FF7954] text-white px-6 py-2 rounded-lg
                       hover:bg-[#e66a45] transition-colors"
            >
              Contact
            </button>
          </nav>

          {/* Menu Mobile */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Menu Mobile Dropdown */}
        {isMenuOpen && (
          <div
            className={`md:hidden absolute top-20 left-0 right-0 py-4 ${
              isScrolled
                ? "bg-[#0A0A0A]/90 backdrop-blur-sm"
                : "bg-[#0A0A0A]/90 backdrop-blur-sm"
            }`}
          >
            <div className="flex flex-col items-center space-y-4">
              <button
                onClick={() => handleSectionClick("accueil")}
                className="text-white hover:text-[#FF7954] transition-colors"
              >
                Accueil
              </button>
              <button
                onClick={() => handleSectionClick("services")}
                className="text-white hover:text-[#FF7954] transition-colors"
              >
                Services
              </button>
              <button
                onClick={() => handleSectionClick("tarifs")}
                className="text-white hover:text-[#FF7954] transition-colors"
              >
                Tarifs
              </button>
              <button
                onClick={onContactClick}
                className="bg-[#FF7954] text-white px-6 py-2 rounded-lg
                         hover:bg-[#e66a45] transition-colors"
              >
                Contact
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
